import SEO from "@/components/SEO";
import { Link } from "react-router-dom";

function Shell({ title, description, canonical, children }) {
  return (
    <>
      <SEO title={`${title} — Tech Alpha SSL`} description={description} canonical={canonical} />
      <section className="pt-20 pb-20">
        <div className="container-page max-w-3xl">
          <span className="eyebrow">Legal</span>
          <h1 className="mt-4 text-4xl md:text-5xl font-semibold tracking-tighter">{title}</h1>
          <p className="mt-2 text-sm text-muted-foreground">Last updated: {new Date().toLocaleDateString()}</p>
          <div className="prose prose-neutral dark:prose-invert mt-8 max-w-none text-[15px] leading-relaxed">
            {children}
          </div>
          <div className="mt-10">
            <Link to="/" className="btn-ghost !py-2 !px-4 !text-sm">Back to home</Link>
          </div>
        </div>
      </section>
    </>
  );
}

export function Privacy() {
  return (
    <Shell title="Privacy Policy" description="How Tech Alpha SSL collects, uses, and protects your data." canonical="https://techalphassl.com/privacy">
      <p>Tech Alpha SSL respects your privacy. This policy explains what information we collect, how we use it, and the choices you have.</p>
      <h3>Information we collect</h3>
      <p>We collect information you provide directly (name, email, phone, company, project details) via our contact and quote forms, and technical information (IP address, browser, device) collected automatically for security and analytics.</p>
      <h3>How we use information</h3>
      <p>To respond to inquiries, deliver services, process payments (via PayPal), send transactional and, if opted-in, marketing communications, and improve our services.</p>
      <h3>Sharing</h3>
      <p>We do not sell personal data. We share limited information with vetted service providers (payment processing, email delivery, analytics) strictly to operate our services.</p>
      <h3>Data retention</h3>
      <p>We retain personal information only as long as necessary to provide services and comply with legal obligations.</p>
      <h3>Your rights</h3>
      <p>You may request access, correction, or deletion of your personal data by emailing techalphassl@gmail.com.</p>
      <h3>Contact</h3>
      <p>Questions? Email <a href="mailto:techalphassl@gmail.com">techalphassl@gmail.com</a>.</p>
    </Shell>
  );
}

export function Terms() {
  return (
    <Shell title="Terms & Conditions" description="The terms that govern use of Tech Alpha SSL services." canonical="https://techalphassl.com/terms">
      <p>By using this website or purchasing services from Tech Alpha SSL, you agree to these terms.</p>
      <h3>Services</h3>
      <p>We provide website design, hosting, SSL certificates, domain registration, security audits, and technical support. Deliverables and scope are documented per engagement.</p>
      <h3>Payments</h3>
      <p>All payments are processed by PayPal Hosted Payments. Prices are in USD unless stated otherwise. Purchases are non-transferable.</p>
      <h3>Acceptable use</h3>
      <p>You agree not to use our services to host or transmit illegal content, malware, or content that infringes intellectual property.</p>
      <h3>Limitation of liability</h3>
      <p>To the maximum extent allowed by law, our aggregate liability is limited to the fees paid for the specific service giving rise to the claim.</p>
      <h3>Changes</h3>
      <p>We may update these terms. Continued use of the site constitutes acceptance of the updated terms.</p>
    </Shell>
  );
}

export function Refund() {
  return (
    <Shell title="Refund Policy" description="Refund terms for Tech Alpha SSL services." canonical="https://techalphassl.com/refund">
      <p>We stand behind our work. This policy outlines when refunds are available.</p>
      <h3>Fixed-scope services</h3>
      <p>Most fixed-scope services (SSL Installation, Security Audit) are refundable within 7 days of purchase, provided work has not begun. Once installation, remediation, or audit activities commence, refunds are pro-rated based on delivered work.</p>
      <h3>Retainer & Enterprise</h3>
      <p>Ongoing retainers can be cancelled at any time with 30 days' notice. Enterprise engagements follow the refund terms of the executed statement of work.</p>
      <h3>How to request</h3>
      <p>Email <a href="mailto:techalphassl@gmail.com">techalphassl@gmail.com</a> with your order details. Refunds are issued via the original PayPal payment method.</p>
    </Shell>
  );
}

export function Cookies() {
  return (
    <Shell title="Cookie Policy" description="How Tech Alpha SSL uses cookies." canonical="https://techalphassl.com/cookies">
      <p>Cookies are small text files stored on your device. We use them to keep the site fast, secure, and personalized.</p>
      <h3>Cookies we use</h3>
      <ul>
        <li><strong>Essential cookies</strong>: session management, security (e.g., admin authentication).</li>
        <li><strong>Analytics cookies</strong>: aggregate site usage (Google Analytics, PostHog).</li>
        <li><strong>Preference cookies</strong>: your theme (light/dark) and other UI preferences.</li>
      </ul>
      <h3>Your choices</h3>
      <p>Most browsers let you block or delete cookies. Blocking essential cookies may impact functionality.</p>
    </Shell>
  );
}
